import { render } from "./RecaptchaCompliance.vue?vue&type=template&id=36c3295b&scoped=true"
import script from "./RecaptchaCompliance.vue?vue&type=script&lang=js"
export * from "./RecaptchaCompliance.vue?vue&type=script&lang=js"

import "./RecaptchaCompliance.vue?vue&type=style&index=0&id=36c3295b&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c3295b"]])

export default __exports__